var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 4,
    stroke: "#CAC9D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54883 5L9.77891 2L10.916 5",
    stroke: "#CAC9D6",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.916 16L9.68593 19L8.54885 16",
    stroke: "#CAC9D6",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26789 12L1.73242 10.9607L4.26789 10",
    stroke: "#CAC9D6",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6237 9.69336L19.1592 10.7326L16.6237 11.6934",
    stroke: "#CAC9D6",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1765 5.6057L16.1677 4.35418L14.8504 7.27954",
    stroke: "#CAC9D6",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07249 15.0574L4.08137 16.3089L5.39865 13.3835",
    stroke: "#CAC9D6",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20007 7.5282L4.14211 5.00046L6.61429 6.11399",
    stroke: "#CAC9D6",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3107 14.3888L16.3686 16.9165L13.8965 15.803",
    stroke: "#CAC9D6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSun);
export default __webpack_public_path__ + "static/media/darkSun.ad3bde43827047c173908456711b3af2.svg";
export { ForwardRef as ReactComponent };